<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VkRE3e/tc-custom/9783968656656.jpg?1703042117671" alt="This image is the cover for the book Ion, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ion, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>In Plato's Ion Socrates discusses with the titular character, a professional rhapsode who also lectures on Homer, the question of whether the rhapsode, a performer of poetry, gives his performance on account of his skill and knowledge or by virtue of divine possession. It is one of the shortest of Plato's dialogues.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Plato
      </h2>
      
      <p class="authorDescription body article">Plato; 428/427 or 424/423–348/347 BC) was an Athenian philosopher during the Classical period in Ancient Greece, founder of the Platonist school of thought, and the Academy, the first institution of higher learning in the Western world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d461c1c